module.exports = __webpack_public_path__ + "assets/3.b983c559.svg";